import { DeviceTask, TaskType } from '@era/device-task-management-sdk';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DeviceScheduledTasksResolverActions = createActionGroup({
  source: 'Device scheduled tasks resolver',
  events: {
    'Scheduled tasks requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DeviceScheduledTasksApiActions = createActionGroup({
  source: 'Device scheduled tasks API',
  events: {
    'Scheduled tasks loaded': props<{ scheduledTasks: DeviceTask[] }>(),
    'Scheduled tasks loaded error': props<{ error: ErrorModel }>(),
    'Scheduled task deleted': props<{ deviceTask: DeviceTask }>(),
    'Scheduled task deleted error': props<{ error: ErrorModel }>(),
    'Scheduled tasks deleted': props<{ udid: string }>(),
    'Scheduled tasks deleted error': props<{ error: ErrorModel }>(),
    'Task scheduled': props<{ udid: string; taskType: TaskType }>(),
    'Task scheduled error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DeviceScheduledTasksUiActions = createActionGroup({
  source: 'Device scheduled tasks UI',
  events: {
    'Scheduled task deleted': props<{ deviceTask: DeviceTask }>(),
    'Scheduled tasks deleted': emptyProps(),
    'Task scheduled': props<{ taskType: TaskType }>(),
  },
});

// ============================================================================
// SIGNALR ACTIONS (Group - using createActionGroup)
// ============================================================================

export const SignalRActions = createActionGroup({
  source: 'SignalR',
  events: {
    'Scheduled tasks updated': props<{ udid: string }>(),
  },
});
